import { io } from "socket.io-client";
import { BASE_URL } from "./Constants/common";

export const socket = io(BASE_URL, {
  autoConnect: false,
  transports: ["websocket"],
  auth: {
    token: localStorage.getItem("accessToken"),
  },
  reconnectionAttempts: 5,
});
